import { AuthProtocolsGetUserInfoResponse, MarqCommonEnumsClientClientTypeEnum } from '~/swagger/data-contracts';
import { RevolutClientId } from '~/utils';

// note@blue-poolyum: 특정 고객사에 한해 Social media 두 가지 페이지를 모두 허용함
export const isAllowedAllSocialMedia = (authData?: AuthProtocolsGetUserInfoResponse) => {
  // note-@blue-poolyum: MR BEAST, Alo, LLC, Revolut, SEGA (개발 환경은 1548, 1742)
  const ALLOWED_IDS =
    import.meta.env.REACT_APP_ENV === 'production' ? [2252, 1876, RevolutClientId, 2805] : [1548, RevolutClientId];

  const isAllowed =
    (authData?.customer_type.primary === MarqCommonEnumsClientClientTypeEnum.Piracy ||
      authData?.customer_type.secondary?.some((type) => type === MarqCommonEnumsClientClientTypeEnum.Piracy)) &&
    ALLOWED_IDS.includes(authData.client_id);

  return isAllowed ?? false;
};

export const isAllowedPiracyPerformance = (authData?: AuthProtocolsGetUserInfoResponse) => {
  const ALLOWED_IDS = [RevolutClientId];

  const isAllowed =
    authData?.customer_type.secondary?.some((type) => type === MarqCommonEnumsClientClientTypeEnum.Piracy) &&
    ALLOWED_IDS.includes(authData.client_id);

  return isAllowed ?? false;
};

export const isAllowPiracyWebsiteContent = (authData?: AuthProtocolsGetUserInfoResponse) => {
  const ALLOWED_IDS = [RevolutClientId];

  const isAllowed =
    authData?.customer_type.secondary?.some((type) => type === MarqCommonEnumsClientClientTypeEnum.Piracy) &&
    ALLOWED_IDS.includes(authData.client_id);

  return isAllowed ?? false;
};

export const isAllowedPiracyAssetsAsSecondary = (authData?: AuthProtocolsGetUserInfoResponse) => {
  const ALLOWED_IDS =
    import.meta.env.REACT_APP_ENV === 'production' ? [2252, 1876, RevolutClientId] : [1548, RevolutClientId];

  const isAllowed =
    (authData?.customer_type.secondary?.some((type) => type === MarqCommonEnumsClientClientTypeEnum.Piracy) &&
      ALLOWED_IDS.includes(authData.client_id)) ||
    (authData?.customer_type.primary !== MarqCommonEnumsClientClientTypeEnum.Piracy &&
      isAllowedAiGeneratedContent(authData));

  return isAllowed ?? false;
};

export const isAllowedAiGeneratedContent = (authData?: AuthProtocolsGetUserInfoResponse) => {
  const ALLOWED_IDS = [1419];

  const isAllowed = ALLOWED_IDS.includes(authData?.client_id ?? -1);

  return isAllowed;
};
